/**
 * @generated SignedSource<<489ee630e128d2f9314b1d08726b196d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetQuery$data = {
  readonly seriesWidgetArticles: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly series?: ReadonlyArray<{
            readonly entityId?: string;
            readonly publishedDate?: number | null | undefined;
          } | null | undefined> | null | undefined;
          readonly seriesShortLabel?: string | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetTabContentArticle">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "seriesWidgetQuery";
};
export type seriesWidgetQuery$key = {
  readonly " $data"?: seriesWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "seriesWidgetArticlesQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesWidgetQuery",
  "selections": [
    {
      "alias": "seriesWidgetArticles",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "seriesWidgetArticlesQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "seriesShortLabel",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "series",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "publishedDate",
                                  "storageKey": null
                                }
                              ],
                              "type": "Content",
                              "abstractKey": "__isContent"
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "seriesWidgetTabContentArticle"
                        }
                      ],
                      "type": "Article",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "dd239d029ed75b3ff597763fbac31ce9";

export default node;
